import SubcategoryPage from '@/components/template/SubcategoryPage';

const Comoda = () => {
  const products = [
    {
      title: "Comoda Classic",
      imageSrc: "https://images.unsplash.com/photo-1595428774223-ef52624120d2?auto=format&fit=crop&q=80",
      url: "/proizvodi/comoda-classic"
    },
    {
      title: "Comoda Modern",
      imageSrc: "https://images.unsplash.com/photo-1589584649628-b597067e07a3?auto=format&fit=crop&q=80",
      url: "/proizvodi/comoda-modern"
    },
    {
      title: "Comoda Premium",
      imageSrc: "https://images.unsplash.com/photo-1604061986761-d9d0cc41b0d1?auto=format&fit=crop&q=80",
      url: "/proizvodi/comoda-premium"
    },
    {
      title: "Comoda Luxury",
      imageSrc: "https://images.unsplash.com/photo-1589584649628-b597067e07a3?auto=format&fit=crop&q=80&w=1200",
      url: "/proizvodi/comoda-luxury"
    },
    {
      title: "Comoda Vintage",
      imageSrc: "https://images.unsplash.com/photo-1595428774223-ef52624120d2?auto=format&fit=crop&q=80&w=1200",
      url: "/proizvodi/comoda-vintage"
    },
    {
      title: "Comoda Elite",
      imageSrc: "https://images.unsplash.com/photo-1604061986761-d9d0cc41b0d1?auto=format&fit=crop&q=80&w=1200",
      url: "/proizvodi/comoda-elite"
    }
  ];

  return (
    <SubcategoryPage
      title="Comoda"
      description="Elegantne komode, ki združujejo klasično oblikovanje in sodobno funkcionalnost za shranjevanje."
      heroImage="https://images.unsplash.com/photo-1595428774223-ef52624120d2?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default Comoda;